import 'regenerator-runtime/runtime.js';
import { useState } from 'react';
import useUnauthorizedAxiosSubmit from './useUnauthorizedAxiosSubmit';

const useGenerateMagicLink = () => {
  const [magicLinkRequest, setMagicLinkRequest] = useState();
  const [url, setUrl] = useState();
  const { response, isLoading, hasErrored } = useUnauthorizedAxiosSubmit(url, magicLinkRequest);

  const generateMagicLink = async (customValues) => {
    setUrl(`${process.env.BRANCH_BASE_URL}/v1/url`);
    const request = {
      branch_key: `${process.env.BRANCH_KEY}`,
      data: {
        custom_object: {
          ...customValues,
        },
        $desktop_url: process.env.BRANCH_FALLBACK_URL,
      },
    };
    setMagicLinkRequest(request);
  };

  return { response, error: hasErrored, isPending: isLoading, generateMagicLink };
};

export default useGenerateMagicLink;
